import React, {useState} from 'react';
import "./forInvestors.css"
import Header from "../components/Header";
import Footer from "../components/Footer";
import main_block_bg from "./images/main_page_bg.svg";


import left_top_banner_image from "./images/Image (1).png";
import left_bottom_banner_image from "./images/Image (2).png";
import right_top_banner_image from "./images/Image (4).png";
import right_bottom_banner_image from "./images/Image (3).png";

import for_investors_icon1 from "./images/for_investors_top_icon1.svg";
import for_investors_icon2 from "./images/for_investors_top_icon2.svg";
import for_investors_icon3 from "./images/for_investors_top_icon3.svg";
import for_investors_icon4 from "./images/for_investors_top_icon4.svg";

import journey_warning_icon from "./images/journey_warning_icon.svg";

import core_ess_gal from "./images/core_essentials_gal.svg";

import investors_protection_image from "./images/investor_potection_img.svg";

import core_essentials_img1 from "./images/core_essentials_img1.png";
import core_essentials_img2 from "./images/core_essentials_img2.png";
import core_essentials_img3 from "./images/core_essentials_img3.png";


import investor_flow_icon1 from "./images/investor_flow1.svg";
import investor_flow_icon2 from "./images/investor_flow2.svg";
import investor_flow_icon3 from "./images/investor_flow3.svg";
import investor_flow_icon4 from "./images/investor_flow4.svg";
import stay_informed_bg_top from "../UnduraCore/images/stay_informed_bg_top.svg";
import InputContainer from "../UnduraCore/components/InputContainer";
import mail_icon from "../UnduraCore/images/mail_icon.svg";
import send_plane_icon from "../UnduraCore/images/send_plane.svg";
import stay_informed_bg_bottom from "../UnduraCore/images/stay_informed_bottom_bg.svg";
import inputNameIcon from "../UnduraCore/images/userNameIcon.svg";
import inputPencilIcon from "../UnduraCore/images/pencilIcon.svg";
import white_logo from "../UnduraCore/images/white_logo.svg";
import FaqItem from "../MainPage/components/FaqItem";
import circles_bg from "../ForDonors/images/circles.svg";
import waves_bg from "../MainPage/images/waves_bg.svg";
import investor_banner_left_mob from "./images/investor_banner_left_mob.png";

import investors_secondary_market from "./images/investors_secondary_market.png";
import investors_protection from "./images/investors_protection.png";
import {motion} from "framer-motion";
import axios from "axios";
import warning_triangle from "../UnduraCore/images/warning_triangle.svg";
import CoreWarning from "../UnduraCore/components/CoreWarning";


const ForInvestors = () => {

    const [contactEmail, setContactEmail] = useState("")
    const [contactFullName, setContactFullName] = useState("")
    const [contactMessage, setContactMessage] = useState("")
    const [subscribeValue, setSubscribeValue] = useState("")

    let sendApiContact = () => {
        axios.post("https://api.undura.com/api/v1/contact", {
            full_name: contactFullName,
            email: contactEmail,
            message: contactMessage,
            honeypot: ""
        }).then(r => console.log(r)).catch((er) => console.error(er))
    }
    let sendApiSubscribe = () => {
        axios.post("https://api.undura.com/api/v1/newsletter/subscribe", {
            email: subscribeValue,
            honeypot: ""
        }).then(r => console.log(r)).catch((er) => console.error(er))
    }
    const hoverScale = { whileHover: { scale: 1.03 }, transition: { type: "spring", stiffness: 250 } };

    const fadeUpItem = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };
    const sectionViewport = { initial: "hidden", whileInView: "visible", viewport: { once: true, amount: 0.3 } };
    const blockVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };
    const staggerVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, delay: i * 0.15, ease: "easeOut" }
        })
    };

    const staggerContainer = {
        hidden: { opacity: 1 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15
            }
        }
    };

    const imageReveal = {
        hidden: { opacity: 0, y: 20, scale: 0.95 },
        visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.7, ease: "easeOut" } }
    };

    const faq_items = [{
        question: "How does UNDURA verify projects?",
        answer: "Each project is verified through our KYB process and partnership checks.\n" +
            "We only list organizations with transparent records and verified payment accounts.\n" +
            "You can also find detailed information and verification status in each project’s description."
    }, {
        question: "Can I get a tax deduction?",
        answer: "Tax deductions depend on the organization’s legal status and your country’s tax laws. Registered charities on Undura Lite can issue donation receipts that donors may use for tax purposes."
    }, {
        question: "How can I track the results?",
        answer: "You’ll get updates and reports directly from the organization in your donor dashboard."
    }, {
        question: "What payment methods are supported?",
        answer: "Donations are processed securely via Stripe — credit card, Apple Pay, and Google Pay."
    }, {
        question: "Are there limits on the donation amount?",
        answer: "There’s no minimum.\n" +
            "For donations above €300, identity verification may be requested for security reasons."
    }]


    const [isFocusedTextarea, setIsFocusedTextarea] = useState(false);

    const focusedTextArea = `textarea_bg ${isFocusedTextarea ? 'focused_textarea' : ''}`;
    const isMobile = window.innerWidth < 768;


    const cardFadeUp = (delay = 0) => ({
        initial: { opacity: 0, y: 40 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.8, ease: "easeOut", delay },
        viewport: { once: true, amount: 0.3 }
    });


    const pointVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.15, duration: 0.6, ease: "easeOut" }
        })
    };
    const fadeNumeric = {
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: true },
        variants: pointVariants
    };

    const fadeUp = { initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const fadeDown = { initial: { opacity: 0, y: -40 }, whileInView: { opacity: 1, y: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const fadeLeft = { initial: { opacity: 0, x: -50 }, whileInView: { opacity: 1, x: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const fadeRight = { initial: { opacity: 0, x: 50 }, whileInView: { opacity: 1, x: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };



    const hoverButton = {
        whileHover: {
            scale: 1.05,
            transition: { type: "spring", stiffness: 300 }
        }
    };


    const buttonAnimate = {
        initial:fadeUp.initial,
        whileInView:fadeUp.whileInView,
        viewport:fadeUp.viewport,
        transition:fadeUp.transition,
        whileHover:hoverButton.whileHover
    }


    return (
        <div className="for_investors_page">
            <CoreWarning/>
            <motion.img src={main_block_bg} alt="" className="main_block_bg" {...fadeUp}/>
            <Header mode="core"/>

            <div className="for_investors_banner">
                <div className="left_top_banner_image_investors">
                    <img src={window.innerWidth < 768 ? investor_banner_left_mob : left_top_banner_image} alt="" {...fadeLeft}/>
                </div>
                <div className="for_investors_banners_text">
                    <motion.div className="for_investors" {...fadeUp}>
                        <div className="circle"></div>
                        For Investors
                    </motion.div>
                    <motion.div className="investors_main_text_banners" {...fadeLeft}>
                        Undura Core provides a verified, compliant, and transparent environment for investors across all
                        participating platforms.
                    </motion.div>
                    <motion.div className="for_investors_banners_desc" {...fadeRight}>
                        Identity, transactions, and records are maintained under ECSPR standards and aligned with MiFID
                        requirements, ensuring clarity and operational integrity at every step.
                    </motion.div>
                    <motion.div className="for_investors_main_buttons">
                        <a href = "#get_in_touch_link">
                        <motion.div className="be_first" {...buttonAnimate}
                                    {...fadeNumeric} custom={0}>Be first
                        </motion.div>
                        </a>
                        <a href = "#cooling_off_link">
                        <motion.div className="how_it_works_button" {...buttonAnimate}
                                    {...fadeNumeric} custom={1}>How it works
                        </motion.div>
                        </a>
                    </motion.div>
                </div>
                <div className="right_top_banner_image_investors">
                    <img src={right_top_banner_image} alt="" {...fadeRight}/>
                </div>

            </div>

            <motion.div className="for_investor_points_top">
                <motion.div className="for_investor_point" {...fadeNumeric} custom={0}>
                    <div className="icon_name_block">
                        <img src={for_investors_icon1} alt=""/>
                        Verified Identity
                    </div>
                    Undura ID with KYC/AML and investor classification under ECSPR.
                </motion.div>
                <motion.div className="for_investor_point" {...fadeNumeric} custom={1}>
                    <div className="icon_name_block">
                        <img src={for_investors_icon2} alt=""/>
                        Transparent Records
                    </div>
                    Immutable portfolio entries, audit-ready logs, and standardized disclosures.
                </motion.div>
                <motion.div className="for_investor_point" {...fadeNumeric} custom={2}>
                    <div className="icon_name_block">
                        <img src={for_investors_icon3} alt=""/>
                        Secure Flows
                    </div>
                    All transactions processed through licensed EMIs with segregated accounts.
                </motion.div>
                <motion.div className="for_investor_point" {...fadeNumeric} custom={3}>
                    <div className="icon_name_block">
                        <img src={for_investors_icon4} alt=""/>
                        Cross-Platform Access
                    </div>
                    A single verified identity usable across multiple investment platforms.
                </motion.div>
            </motion.div>

            <motion.div className="for_investors mt80" {...fadeUp}>
                <div className="circle"></div>
                Instruments & Investor Eligibility
            </motion.div>

            <motion.div className="main_text" {...fadeLeft}>
                <span>Instruments </span> Overview
            </motion.div>

            <motion.div className="investor_flow_points">
                <motion.div className="investor_flow_point" {...fadeNumeric} custom={0}>
                    <div className="icon_number"><img src={investor_flow_icon1} alt=""/><div className="number_core">Step 1</div></div>
                    <div className="about_core_point_name">Loans</div>
                    <div className="about_core_point_desc">ECSPR scope, fixed income, risk disclosures.</div>
                </motion.div>
                <motion.div className="investor_flow_point"  {...fadeNumeric} custom={1}>
                    <div className="icon_number"><img src={investor_flow_icon2} alt=""/><div className="number_core">Step 2</div></div>
                    <div className="about_core_point_name">Bonds</div>
                    <div className="about_core_point_desc">Repayment rules, issuer obligations.</div>
                </motion.div>
                <motion.div className="investor_flow_point"  {...fadeNumeric} custom={2}>
                    <div className="icon_number"><img src={investor_flow_icon3} alt=""/><div className="number_core">Step 3</div></div>
                    <div className="about_core_point_name">Equity</div>
                    <div className="about_core_point_desc">Ownership records, transfer rules.</div>
                </motion.div>
            </motion.div>

            <motion.div className="journey_warning" {...fadeUp} transition={{ type: "spring", stiffness: 300 }}>
                <img src={journey_warning_icon} alt=""/>
                <div className="warning_info">
                    <span>Important:</span> Eligibility depends on the investor type (sophisticated / non-sophisticated) and outcomes of the knowledge test, as required by ECSPR Art. 21–22.
                </div>
            </motion.div>
            <a href = "#get_in_touch_link">
            <motion.div className="compliance_be_first_button" {...buttonAnimate} {...fadeUp}>
                Be first
            </motion.div>
            </a>

            <motion.div className="main_text mt_big" {...fadeUp}>
                <span>Undura</span> Core Essentials
            </motion.div>

            <motion.div className="key_featuers_blocks">
                <motion.div className="key_featuers_point" {...fadeNumeric} custom={0}>
                    <img src={core_essentials_img1} alt=""/>
                    <div className="key_features_desc">
                        <div className="essentials_point"><img src={core_ess_gal} alt=""/>Verified Undura ID</div>
                        <div className="essentials_point"><img src={core_ess_gal} alt=""/>GDPR-aligned data storage</div>
                        <div className="essentials_point"><img src={core_ess_gal} alt=""/>Immutable portfolio records</div>
                    </div>
                </motion.div>

                <motion.div className="key_featuers_point" {...fadeNumeric} custom={1}>
                    <img src={core_essentials_img2} alt=""/>
                    <div className="key_features_desc">
                        <div className="essentials_point"><img src={core_ess_gal} alt=""/>Segregated funds</div>
                        <div className="essentials_point"><img src={core_ess_gal} alt=""/>Licensed EMI/PI flow</div>
                        <div className="essentials_point"><img src={core_ess_gal} alt=""/>Safe execution of investments</div>
                    </div>
                </motion.div>

                <motion.div className="key_featuers_point" {...fadeNumeric} custom={2}>
                    <img src={core_essentials_img3} alt=""/>
                    <div className="key_features_desc">
                        <div className="essentials_point"><img src={core_ess_gal} alt=""/>KYC / AML</div>
                        <div className="essentials_point"><img src={core_ess_gal} alt=""/>Conflicts-of-interest controls</div>
                        <div className="essentials_point"><img src={core_ess_gal} alt=""/>Standardized disclosures (KIIS)</div>
                    </div>
                </motion.div>
            </motion.div>


            <div className="white_label">
                <motion.div className="white_label_info" {...fadeLeft}>
                    <div className="secondary_roadmap"><div className="circle"></div>Roadmap</div>
                    <div className="white_label_name">Secondary Market</div>
                    <div className="white_label_desc">
                        Planned compliant exchange layer under MiFID II, enabling cross-platform transfers within the Undura Network. Available after licensing.
                    </div>
                    <motion.a href = "/architecture" className="issuer_article_button" {...buttonAnimate}>
                        View Architecture
                    </motion.a>
                </motion.div>
                <motion.div className="white_label_image" {...fadeRight}>
                    <img src={investors_secondary_market} alt=""/>
                </motion.div>
            </div>


            <motion.div className="main_text" {...fadeLeft}>
                <span>Fees &</span> Investor Conditions
            </motion.div>

            <motion.div className="for_investor_points_top mb_middle">
                <motion.div className="for_investor_point"  {...fadeNumeric} custom={0}>
                    <div className="icon_name_block">
                        <img src={for_investors_icon1} alt=""/>
                        No Account Fees
                    </div>
                    Undura ID with KYC/AML and investor classification under ECSPR.
                </motion.div>

                <motion.div className="for_investor_point" {...fadeNumeric} custom={1}>
                    <div className="icon_name_block">
                        <img src={for_investors_icon2} alt=""/>
                        EMI Fees
                    </div>
                    Immutable portfolio entries, audit-ready logs, and standardized disclosures.
                </motion.div>

                <motion.div className="for_investor_point" {...fadeNumeric} custom={2}>
                    <div className="icon_name_block">
                        <img src={for_investors_icon3} alt=""/>
                        Standardized Disclosures
                    </div>
                    All transactions processed through licensed EMIs with segregated accounts.
                </motion.div>

                <motion.div className="for_investor_point" {...fadeNumeric} custom={3}>
                    <div className="icon_name_block">
                        <img src={for_investors_icon4} alt=""/>
                        Clear Schedules
                    </div>
                    A single verified identity usable across multiple investment platforms.
                </motion.div>
            </motion.div>

            <a href = "#get_in_touch_link">
            <motion.div
                className="compliance_be_first_button protect"
                {...buttonAnimate}
                {...fadeUp}
            >
                Be first
            </motion.div>
            </a>

            <div className="investors_protection_fs" id = "cooling_off_link">
                <div className="investors_protection">

                    <div className="investors_protection_info">
                        {[
                            { name: "Cooling-off Period", desc: "4 days for non-sophisticated investors to reconsider investments" },
                            { name: "Knowledge Test", desc: "Mandatory assessment to ensure investor understanding" },
                            { name: "Risk Warnings", desc: "Clear and comprehensive disclosure of investment risks" },
                            { name: "Conflict-of-Interest Safeguards", desc: "Transparent processes to identify and manage conflicts" },
                            { name: "Outcome Statements", desc: "Regular reporting on investment performance and status" },
                        ].map((item, index) => {
                            if (isMobile) {
                                return (
                                    <div className="investor_protection_point" key={index}>
                                        <div className="investor_protection_point_name">{item.name}</div>
                                        <div className="investor_protection_point_desc">{item.desc}</div>
                                    </div>
                                );
                            } else {
                                return (
                                    <motion.div
                                        className="investor_protection_point"
                                        key={index}
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.6, delay: 0.1 * index }}
                                        viewport={{ once: true }}
                                    >
                                        <div className="investor_protection_point_name">{item.name}</div>
                                        <div className="investor_protection_point_desc">{item.desc}</div>
                                    </motion.div>
                                );
                            }
                        })}
                    </div>


                    <motion.div
                        className="investors_protection_image"
                        initial={isMobile ? {} : { opacity: 0, x: -50 }}
                        whileInView={isMobile ? {} : { opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <img src={investors_protection} alt=""/>
                    </motion.div>

                    <div className="investor_protection_name_mobile">Investor Protections</div>
                </div>
            </div>



            <motion.div className="main_text" {...sectionViewport} variants={fadeUp}>
                Questions you might have
            </motion.div>

            <motion.div className="faq_full" {...sectionViewport} variants={staggerContainer}>
                <motion.div className="faq_main" variants={staggerContainer}>
                    {faq_items.map((e, idx) => (
                        <motion.div key={idx} variants={fadeUpItem}>
                            <FaqItem answer={e.answer} question={e.question}/>
                        </motion.div>
                    ))}
                </motion.div>

                <motion.div className="bg_circles" variants={imageReveal}><img alt="" src={circles_bg}/></motion.div>
            </motion.div>

            <motion.div
                className="stay_informed_block"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={blockVariants}
            >
                <div className="stay_informed_block_info">
                    <img src={stay_informed_bg_top} alt="" className="stay_informed_bg_top"/>
                    <motion.div className="stay_informed_content" initial="hidden" animate="visible">
                        {[
                            "Powered by Undura Core",
                            "Stay informed about Undura Core updates",
                            "Subscribe to receive early access to technical releases, integration notes, and documentation updates.\n\nInformation is shared periodically and limited to infrastructure and regulatory developments."
                        ].map((text, i) => (
                            <motion.div key={i} custom={i} variants={staggerVariants}>
                                {i === 0 ? (
                                    <div className="powered_by"><div className="circle"></div>{text}</div>
                                ) : i === 1 ? (
                                    <div className="stay_informed_main">{text}</div>
                                ) : (
                                    <div className="stay_informed_desc">{text}</div>
                                )}
                            </motion.div>
                        ))}
                        <motion.div custom={3} variants={staggerVariants} className = "mob_100">
                            <InputContainer inputPlaceholder="your.email@organization.com" inputIcon={mail_icon} inputType="email" value={subscribeValue} onChange={(el) => {
                                setSubscribeValue(el.target.value)
                            }}>
                                <div className="send_button" onClick={() => {
                                    sendApiSubscribe()
                                }}>
                                    <img src={send_plane_icon} alt=""/>
                                </div>
                            </InputContainer>
                        </motion.div>
                    </motion.div>
                    <img src={stay_informed_bg_bottom} alt="" className="stay_informed_bg_bottom"/>
                </div>
            </motion.div>

            <a name = "get_in_touch_link"></a>
            <motion.div className="get_in_touch_full_block" {...sectionViewport} variants={staggerContainer}>
                <motion.div className="get_in_touch_block" variants={staggerContainer}>
                    <motion.div className="get_in_touch_message_block" variants={fadeUpItem}>
                        <motion.div className="get_in_touch_name" variants={fadeUpItem}>
                            Get in Touch
                        </motion.div>
                        <form className="get_in_touch_form">
                            <div className="input_name">Full Name<span>*</span></div>
                            <motion.div variants={fadeUpItem}>
                                <InputContainer inputPlaceholder="James Brown" inputIcon={inputNameIcon} inputType="text" value={contactFullName} onChange={(e) => {
                                    setContactFullName(e.target.value)
                                }}/>
                            </motion.div>

                            <div className="input_name">E-mail<span>*</span></div>
                            <motion.div variants={fadeUpItem}>
                                <InputContainer inputPlaceholder="hello@undura.com" inputIcon={mail_icon} inputType="text" value={contactEmail} onChange={(e) => {
                                    setContactEmail(e.target.value)
                                }}/>
                            </motion.div>

                            <div className="input_name">Your message<span>*</span></div>
                            <div className="textarea_container">
                                <motion.div className={focusedTextArea} variants={fadeUpItem}>
                                    <img src={inputPencilIcon} alt=""/>
                                    Type here
                                </motion.div>
                                <textarea className="type_here_textarea" onFocus={() => {
                                    setIsFocusedTextarea(true)
                                }} onBlur={(e) => {
                                    if (e.target.value.length === 0) {
                                        setIsFocusedTextarea(false)
                                    }
                                }} value={contactMessage} onChange={(e) => {
                                    setContactMessage(e.target.value)
                                }}/>
                            </div>
                            <motion.button className="get_in_touch_form_submit" type="submit"
                                           onClick={(e) => {
                                               e.preventDefault()
                                               sendApiContact()
                                           }} variants={fadeUpItem} {...hoverScale}>
                                Submit Inquiry
                            </motion.button>
                        </form>
                    </motion.div>

                    <motion.div className="about_undura_get_in_touch" variants={fadeUpItem}>
                        <img src={white_logo} alt=""/>

                        <div className="about_undura_get_in_touch_main_text">
                            Reach out to discuss partnership opportunities, platform integration,
                            or other collaboration formats within the Undura ecosystem.
                        </div>
                        <div className="about_undura_get_in_touch_desc">
                            Messages are handled directly by the Core team.
                        </div>
                    </motion.div>
                </motion.div>
            </motion.div>

            <Footer/>
        </div>
    );
};

export default ForInvestors;